'use strict';

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory(require("q"), require("jsbridge"), require("tracker"));else if (typeof define === 'function' && define.amd) define("mtop", ["q", "jsbridge", "tracker"], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["mtop"] = factory(require("q"), require("jsbridge"), require("tracker"));else root["mtop"] = factory(root["q"], root["jsbridge"], root["tracker"]);
})(undefined, function (__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};
			/******/
			/******/ // The require function
			/******/function __webpack_require__(moduleId) {
				/******/
				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;
				/******/
				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };
				/******/
				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
				/******/
				/******/ // Flag the module as loaded
				/******/module.loaded = true;
				/******/
				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}
			/******/
			/******/
			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;
			/******/
			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;
			/******/
			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "/build/";
			/******/
			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = __webpack_require__(1);

			/***/
		},
		/* 1 */
		/***/function (module, exports, __webpack_require__) {

			/**
    * @description mpi/mtop
    * @author meng.limeng@alibaba-inc.com
    */

			'use strict';

			var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
				return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
			} : function (obj) {
				return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
			};

			var _q = __webpack_require__(2);

			var _q2 = _interopRequireDefault(_q);

			var _jsbridge = __webpack_require__(3);

			var _jsbridge2 = _interopRequireDefault(_jsbridge);

			var _tracker = __webpack_require__(4);

			var _tracker2 = _interopRequireDefault(_tracker);

			function _interopRequireDefault(obj) {
				return obj && obj.__esModule ? obj : { default: obj };
			}

			__webpack_require__(5);

			/**
    * Object.assign polyfill
    */
			if (!Object.assign) {
				Object.defineProperty(Object, "assign", {
					enumerable: false,
					configurable: true,
					writable: true,
					value: function value(target, firstSource) {
						"use strict";

						if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
						var to = Object(target);
						for (var i = 1; i < arguments.length; i++) {
							var nextSource = arguments[i];
							if (nextSource === undefined || nextSource === null) continue;
							var keysArray = Object.keys(Object(nextSource));
							for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
								var nextKey = keysArray[nextIndex];
								var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
								if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
							}
						}
						return to;
					}
				});
			}

			//适配http|https，无域环境下默认http

			//mtop 请求域判断，与页面一级域相同，保证cookie操作权限
			var hostname = window.location.hostname,
			    arrMtopWhiteHostWechat = [// 阿里旅行针对微信增设域名白名单
			'asczwa.com', 'asczxcefsv.com', 'bcvbw.com',
			// 以上3个域名可能会强制跳转到https，造成访问可能有问题，但是为避免多次上线，在这里一次性先放开

			'dfkhgj.com', 'edcdfg.com', 'ereuiib.com', 'fdfgdf.cn', 'iuynfg.com', 'jhgtgb.com', 'mnbvbqw.com'],
			    hostRegexp = /.*?([^.]+)(?:\.x)?\.(alitrip|taobao|tmall|etao|alibaba|alipay|aliyun)\.(com|net).*/i,
			    hostWechatRegexp = /.*?([^.]+)(?:\.x)?\.(asczwa|asczxcefsv|bcvbw|dfkhgj|edcdfg|ereuiib|fdfgdf|iuynfg|jhgtgb|mnbvbqw)\.(com|cn).*/i,
			    domainRegexp = new RegExp('(?:' + arrMtopWhiteHostWechat.join('|').replace(/\./g, '\\.') + ')$'),
			    domainMatch = hostname.match(domainRegexp),
			   
			//匹配当前域名
			domain = domainMatch && domainMatch[0] || (/\.alitrip\./.test(hostname) ? 'alitrip' : 'taobao') + '.' + (/\.net/.test(hostname) ? 'net' : 'com'),
			   
			// 如果在微信白名单域名，直接match，不在时，走原来逻辑

			//当前环境变量
			env = function () {
				var type = hostname.indexOf('x.taobao.net') > 0 ? 'waptest' : 'm';
				var host = hostname.match(hostRegexp) || hostname.match(hostWechatRegexp);
				if (host && ['waptest', 'wapa', 'm', 'waptest2nd'].indexOf(host[1]) > -1) {
					type = host[1];
				}
				return type;
			}();

			var PROJECT_VERSION = _tracker2.default && _tracker2.default._getSrcVersion() || '';

			//线上 mtop 请求锁定 https，日常/预发 mtop 仅支持http
			var protocol = 'https:';
			if (!/https:/i.test(location.protocol) && (env === 'waptest' || env === 'wapa')) {
				protocol = 'http:';
			}
			// 微信白名单域名，自适应协议头
			if (domainMatch) {
				protocol = location.protocol;
			}

			//tbpass同步地址
			var passURL = protocol + '//login.<%= domain %>/jump?target=<%= redirect %>';
			//登录地址
			var loginURL = protocol + '//login.<%= env %>.<%= domain %>/login.htm?tpl_redirect_url=<%= redirect %>';

			//mtop请求队列，串行
			var requestQueue = [],
			   

			//标记mtop运行状态
			isRunning = false,
			   

			//jsonp callback唯一标志位
			jsonpInc = 1;

			var sendPerformanceLog = function sendPerformanceLog(options, type) {
				/*
     tracker && tracker.sendCustomPerformanceLog({
     mtopName: options.api,
     useNative: options.useNative,
     spendTime: new Date() - beginTime,
     type: type
     });*/
				var _trackType = {
					"TIMEOUT": "timeout",
					"ACTIVE_ABORT": "abort",
					"success": "success",
					"failure": "failure"
				};
				_tracker2.default && _tracker2.default.timelineEnd && _tracker2.default.timelineEnd(options.api, _trackType[type] || type, {
					useNative: options.useNative
				}, "mtop");
			};

			//处理钱包下桥可用（创建桥的方式是异步的）
			function alipayCall(fn) {
				fn = fn || function () {};
				if (window.AlipayJSBridge && AlipayJSBridge.call) {
					fn();
				} else {
					document.addEventListener('AlipayJSBridgeReady', fn, false);
				}
			}

			/**
    * Dispatch an event with props to el
    */
			function fireEvent(el, eventType, props) {
				var event = document.createEvent('Events');
				var bubbles = true;
				if (props) {
					for (var name in props) {
						if ({}.hasOwnProperty.call(props, name)) {
							name === 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
						}
					}
				}
				event.initEvent(eventType, bubbles, true);
				el.dispatchEvent(event);
			}

			/**
    * uid生成器
    * */
			var randomUID = function randomUID() {
				var chars = 'abcdefghijklmnopqrstuvwxyz',
				    len = 8,
				    out = '';

				for (var i = 0, clen = chars.length; i < len; i++) {
					out += chars.substr(0 | Math.random() * clen, 1);
				}

				return randomUID.uids[out] ? randomUID(len) : randomUID.uids[out] = out;
			};
			randomUID.uids = {};

			/**
    * 将所有的请求保存下来
    * */
			var requestHistory = {};

			var Util = {
				/**
     * 判断容器
     * {object}
     */
				container: function () {
					var isAlipay = false,
					    isAlitrip = false,
					    isTaobao = false,
					    isTmall = false;

					//钱包
					isAlipay = function () {
						return (/AlipayClient/i.test(navigator.userAgent)
						);
					}();
					//去啊
					isAlitrip = function () {
						return (/AliTrip/i.test(navigator.userAgent)
						);
					}();

					//手淘 version >= 5.2.9 接口人@四海
					isTaobao = function () {
						return (/Aliapp\(TB/i.test(navigator.userAgent)
						);
					}();

					isTmall = function () {
						return (/AliApp\(TM/i.test(navigator.userAgent)
						);
					}();

					return {
						isAlipay: isAlipay,
						isAlitrip: isAlitrip,
						isTaobao: isTaobao,
						isTmall: isTmall
					};
				}(),
				//是否使用native 代理mtop请求
				useNative: function useNative(options) {
					if (this.container.isAlitrip) {
						return options.alitrip;
					} else if (this.container.isAlipay) {
						return options.alipay && this.compareVersion('AlipayClient', '9.0.1') >= 0;
					} else if (this.container.isTaobao) {
						return options.taobao && (_jsbridge2.default.device.type === 'android' && this.compareVersion('TB', '5.2.12') >= 0 || _jsbridge2.default.device.type === 'ios' && this.compareVersion('TB', '5.2.9') >= 0) && window.WindVane;
					} else if (this.container.isTmall) {
						return options.tmall && this.compareVersion('TM', '5.2.0') >= 0 && window.WindVane;
					} else {
						return false;
					}
				},
				//relVersion 高时，返回-1；如果两者相等，返回0；低时则返回1
				compareVersion: function compareVersion(appUA, relVersion, digit) {
					var reg = new RegExp(appUA + '[\\s\\/]([\\d\\.]+)', 'i'),
					    match = navigator.userAgent.match(reg),
					    appVersion = match && match[1] ? match[1] : 0;

					if (!appVersion) {
						return -1;
					}

					var v = appVersion.split('.'),
					    r = relVersion.split('.'),
					    d = digit || v.length,
					    i = -1;

					while (++i < d) {
						var _v = Number(v[i]) || 0,
						    _r = Number(r[i]) || 0;

						if (_v > _r) {
							return 1;
						} else if (_v < _r) {
							return -1;
						}
					}

					return 0;
				},
				/**
     * 删cookie
     * @param name
     */
				deleteCookie: function deleteCookie(name, domain, path) {
					var now = new Date();
					var path = path || '/';
					var domain = domain || window.location.hostname;

					now.setTime(now.getTime() - 1000);
					document.cookie = name + '=;path=' + path + ';domain=' + domain + ';expires=' + now.toGMTString();
				},
				/**
     * 查cookie
     * @param name
     * @returns {*}
     */
				getCookie: function getCookie(name) {
					var match = new RegExp('(?:^|;\\s*)' + name + '\\=([^;]+)(?:;\\s*|$)').exec(document.cookie);
					if (match) {
						return match[1];
					} else {
						return null;
					}
				},
				//跳转去登录
				goLogin: function goLogin() {
					var self = this;

					if (this.isGoingToLogin) {
						return;
					}

					this.isGoingToLogin = true;

					_jsbridge2.default.getEnv().then(function (env) {
						self.isGoingToLogin = false;
						var _domain = domain.replace(/alitrip/i, 'taobao');
						//alitrip域下改写回调地址主动同步登陆态
						if (location.href.indexOf('.alitrip.') > -1 && !_jsbridge2.default.isAlitrip && !_jsbridge2.default.isTaobao && !_jsbridge2.default.isAlipay) {
							var pass_redirect = passURL.replace(/\<\%\=\s*env\s*\%\>/i, env).replace(/\<\%\=\s*domain\s*\%\>/i, _domain).replace(/\<\%\=\s*redirect\s*\%\>/i, encodeURIComponent(location.href));
							location.href = loginURL.replace(/\<\%\=\s*env\s*\%\>/i, env).replace(/\<\%\=\s*domain\s*\%\>/i, _domain).replace(/\<\%\=\s*redirect\s*\%\>/i, encodeURIComponent(pass_redirect));
						} else {
							location.href = loginURL.replace(/\<\%\=\s*env\s*\%\>/i, env).replace(/\<\%\=\s*domain\s*\%\>/i, _domain).replace(/\<\%\=\s*redirect\s*\%\>/i, encodeURIComponent(location.href));
						}
					});
				},
				getAppKey: function getAppKey() {
					var appKey = 'J_app_key';
					var el = document.getElementById(appKey);
					if (el) {
						return el.value;
					} else {
						return env === 'waptest' ? '4272' : '12574478';
					}
				},

				deleteToken: function deleteToken(domain, path) {
					this.deleteCookie(this.TOKEN_KEY, domain, path);
				},

				mergeParams: function mergeParams(o) {
					var r = {},
					    k,
					    v;

					for (k in o) {
						v = o[k];
						if (o.hasOwnProperty(k)) {
							if (typeof v === 'function') {
								r[k] = v();
							} else {
								r[k] = v;
							}
						}
					}

					return r;
				},

				parseParams: function parseParams(params) {
					return this.mergeParams(params);
				},

				//触发mtop队列运行
				request: function request(options, success, failure) {
					var self = this;
					options.v = options.v || '*';

					//H5通过jsonp方式请求mtop，需要将对象参数data序列化
					if ((!options.useNative || !this.useNative(options)) && _typeof(options.data) === 'object') {
						options.data = JSON.stringify(options.data || {}) || '{}';
					}

					self.sendInQueue(options, success, failure);
				},

				//mtop请求入栈
				sendInQueue: function sendInQueue(options, success, failure) {
					var request = [options, success, failure];

					requestQueue.push(request);

					requestHistory[options.uid].status = 'inQueue';
					requestHistory[options.uid].abort = function () {
						for (var i = 0, len = requestQueue.length; i < len; i++) {
							if (requestQueue[i] === request) {
								requestQueue.splice(i, 1);
								requestHistory[options.uid].status = 'complete';
								break;
							}
						}
					};

					this.runNextInQueue();
				},
				runNextInQueue: function runNextInQueue() {
					if (requestQueue.length && !isRunning) {
						isRunning = true;
						var oneMtopConfig = requestQueue.shift();
						requestHistory[oneMtopConfig[0].uid].status = 'outQueue';
						this.sendRequest.apply(this, oneMtopConfig);
					}
				},
				sendRequest: function sendRequest(options, success, failure) {
					var self = this,
					    callback = this.createHandler(options, success, failure);

					function _noNeedToValidate(e) {
						//S.one(document).detach('sufei:validateDone', _validateDone);
						//S.one(document).detach('sufei:noNeedToValidate', _noNeedToValidate);
						document.removeEventListener('sufei:validateDone', _validateDone);
						document.removeEventListener('sufei:noNeedToValidate', _noNeedToValidate);

						//console.log('sufei通知未爬--goon', e[0].api);
						callback.apply(this, [e[0]]);
					}

					function _validateDone(e) {
						//S.one(document).detach('sufei:validateDone', _validateDone);
						document.removeEventListener('sufei:validateDone', _validateDone);

						//console.log('sufei验证OK---重发请求');
						//var _options = S.clone(options);
						var _options = Object.assign(options);

						try {
							var sm = eval('({' + e[0].replace(/&/g, ',').replace(/\=/g, ':').replace(/([^\,\:]+)/g, '"$1"') + '})');

							//_options.data = S.merge(JSON.parse(_options.data || {}), sm);
							_options.data = Object.assign({}, JSON.parse(_options.data || {}), sm);

							_options.data = JSON.stringify(_options.data);
						} catch (e) {
							console.log(e);
						}

						//重发请求
						self.getApiUrlPromise(_options).then(function (url) {
							self.send(url, callback, _options);
						}, function () {

							//callback(S.merge(_options, {
							//  ret: ['ACTIVE_ABORT::手动中止请求']
							//}));

							callback(Object.assign({}, _options, {
								ret: ['ACTIVE_ABORT::手动中止请求']
							}));
						});
					}

					//需要验证且用户验证通过后，重发请求(sufei会广播：sufei:validateDone)
					//S.one(document).on('sufei:validateDone', _validateDone);
					//无需验证，继续处理response(sufei会广播：sufei:noNeedToValidate)
					//S.one(document).on('sufei:noNeedToValidate', _noNeedToValidate);

					//需要验证且用户验证通过后，重发请求(sufei会广播：sufei:validateDone)
					document.addEventListener('sufei:validateDone', _validateDone);
					//无需验证，继续处理response(sufei会广播：sufei:noNeedToValidate)
					document.addEventListener('sufei:noNeedToValidate', _noNeedToValidate);

					this.getApiUrlPromise(options).then(function (url) {
						self.send(url, callback, options);
					});
				},
				createHandler: function __callee(options, success, failure) {
					var that = this;

					//tracker mtop请求发出前的接口信息
					try {
						_tracker2.default && _tracker2.default.log('requestLog', {
							request: options
						}, null, "mtop");
					} catch (e) {
						console.log(e);
					}

					//token异常重试控制，最多允许三次重试
					__callee.failTimes = __callee.failTimes || 0;
					var maxFailTimes = 3;

					function _callee(json) {
						var ret = (json && json.ret || []).join(',');
						// ret = "TOKEN_EMPTY";

						//请求正常返回
						if (/SUCCESS/i.test(ret)) {
							isRunning = false;
							that.runNextInQueue();

							//容错，回调出错不阻断mtop请求队列继续运行
							try {
								success && success(json);
							} catch (e) {
								console.log(e);
							}

							return;
						}

						//token失效
						//FAIL_SYS_TOKEN_EXOIRED应该为笔误，兼容掉
						if (/TOKEN_EMPTY|TOKEN_EXPIRED|TOKEN_EXOIRED/i.test(ret)) {
							//允许重试3次
							if (__callee.failTimes++ < maxFailTimes) {
								that.sendRequest(options, success, failure);
							} else {
								//置回
								__callee.failTimes = 0;

								that.deleteToken();
								isRunning = false;
								that.runNextInQueue();
								//容错，回调出错不阻断mtop请求队列继续运行
								try {
									failure && failure(json);
								} catch (e) {
									console.log(e);
								}
							}

							//mtop token异常打点跟踪
							(function () {
								try {
									var error = ret.split('::');
									if (_tracker2.default && _tracker2.default.log) {

										_tracker2.default.log(json.api, {
											errorName: 'MTOP_ERROR::TOKEN',
											errorCode: error[0],
											errorMesage: error[1] || 'mtop token异常',
											errorDetail: json.api,
											v: json.v,
											useNative: options.useNative
										}, null, "mtop");
									}
								} catch (e) {
									console.log(e);
								}
							})();

							return;
						}

						//session失效
						if (/SESSION_EXPIRED|SID_INVALID|AUTH_REJECT|NEED_LOGIN/.test(ret)) {
							//mtop session异常打点跟踪
							(function () {
								try {
									var error = ret.split('::');
									if (_tracker2.default && _tracker2.default.log) {

										_tracker2.default.log(json.api, {
											errorName: 'MTOP_ERROR::SESSION',
											errorCode: error[0],
											errorMesage: error[1] || 'mtop session异常',
											errorDetail: json.api,
											v: json.v,
											useNative: options.useNative
										}, null, "mtop");
									}
								} catch (e) {
									console.log(e);
								}
							})();

							//非app代理登录，跳到H5登录页引导用户登录
							if (options.needLogin) {
								that.goLogin();
								return;
							}

							isRunning = false;
							that.runNextInQueue();
							//容错，回调出错不阻断mtop请求队列继续运行
							try {
								failure && failure(json);
							} catch (e) {
								console.log(e);
							}

							return;
						}

						//mtop平台接入层 防刷/限流 处理
						if (/FAIL_SYS_USER_VALIDATE|FAIL_SYS_TRAFFIC_LIMIT/i.test(ret)) {
							//打点跟踪
							(function () {
								try {
									var error = ret.split('::');
									if (_tracker2.default && _tracker2.default.log) {

										_tracker2.default.log(json.api, {
											errorName: true ? 'FAIL_SYS_USER_VALIDATE' : 'FAIL_SYS_TRAFFIC_LIMIT',
											errorCode: error[0],
											errorMesage: /FAIL_SYS_USER_VALIDATE/i.test(ret) ? 'mtop平台接入层防刷' : 'mtop平台接入层限流',
											errorDetail: json.api,
											v: json.v,
											useNative: options.useNative
										}, null, "mtop");
									}
								} catch (e) {
									console.log(e);
								}
							})();

							//跳转mtop平台异常页面，引导用户输入验证码或其他操作
							if (json.data && json.data.url) {
								window.location.replace(json.data.url);
							} else {
								isRunning = false;
								that.runNextInQueue();

								//容错，回调出错不阻断mtop请求队列继续运行
								try {
									failure && failure(json);
								} catch (e) {
									console.log(e);
								}
							}

							return;
						}

						//mtop 其他异常打点跟踪
						(function () {
							try {
								var error = ret.split('::');
								if (_tracker2.default && _tracker2.default.log) {

									_tracker2.default.log(json.api, {
										errorName: 'MTOP_ERROR::OTHER',
										errorCode: error[0],
										errorMesage: error[1] || 'mtop 其他异常',
										errorDetail: json.api,
										v: json.v,
										useNative: options.useNative
									}, null, "mtop");
								}
							} catch (e) {
								console.log(e);
							}
						})();

						isRunning = false;
						that.runNextInQueue();
						//容错，回调出错不阻断mtop请求队列继续运行
						try {
							failure && failure(json);
						} catch (e) {
							console.log(e);
						}
					}

					return _callee;
				},
				getApiUrlPromise: function getApiUrlPromise(options) {
					var self = this;
					var deferred = _q2.default.defer();

					//处理参数值，如果里面有函数，那么取函数的返回值
					//options = this.parseParams(S.clone(options));
					options = self.parseParams(Object.assign({}, options));

					requestHistory[options.uid].abort = function () {
						deferred.reject();
					};

					// 获取ttid
					_jsbridge2.default.getTTid().then(function (ttid) {
						//使用去啊、手淘的SPDY协议代理mtop请求，提升性能
						if (options.useNative && self.useNative(options)) {
							//处理
							if (!options['ttid'] && ttid) {
								options['ttid'] = ttid;
							}
							deferred.resolve(options);
							return;
						}

						//非native代理环境，H5自己发送jsonp请求mtop
						var host = hostname.match(hostRegexp);
						var apiUrl = protocol + '//' + [
						//api头，一淘下api被占
						host && host[2] === 'etao' ? 'apie' : 'api',
						//环境变量
						env,
						//当前域
						domain].join('.');

						//api3
						//apiUrl  += '/rest/' + mtop.name;
						//api4
						apiUrl += '/h5/' + options.api + '/' + options.v;

						var apiParams = [];

						apiParams.push('callback=jsonpCallback');

						if (options.type) {
							apiParams.push('type=' + options.type);
							delete options.type;
						}

						//若为POST，业务数据通过body体传递，避免url超限
						var filters = ['timeout'];
						if (options.method === 'post') {
							filters.push('data');
						}
						for (var key in options) {
							if (filters.indexOf(key) > -1) {
								continue;
							}
							apiParams.push(key + '=' + encodeURIComponent(options[key]));
						}

						if (ttid) {
							apiParams.push('ttid=' + ttid);
						}

						var sprefer = location.search.match(/sprefer=([^=&]+)/);
						if (sprefer && sprefer[1]) {
							apiParams.push('sprefer=' + sprefer[1]);
						}

						var t = new Date().getTime();
						apiParams.push('appKey=' + self.getAppKey());
						apiParams.push('t=' + t);

						self.getSignPromise(options.data, t).then(function (sign) {
							apiParams.push('sign=' + sign);
							var url = apiUrl + '?' + apiParams.join('&');
							deferred.resolve(url);
						});
					});

					return deferred.promise;
				},
				/**
     * 利用分配的token对请求的url参数生成摘要值sign，mtop利用这个值和cookie中的token来防止url篡改
     * @param str
     * @param t
     * @returns {defer.promise}
     */
				getSignPromise: function getSignPromise(str, t) {
					var that = this;

					var deferred = _q2.default.defer();

					Util.getMTopTokenPromise().then(function (token) {
						var sign = that.md5(token + '&' + t + "&" + that.getAppKey() + "&" + str);

						deferred.resolve(sign);
					});

					return deferred.promise;
				},

				TOKEN_KEY: '_m_h5_tk',
				getMTopTokenPromise: function getMTopTokenPromise() {
					var deferred = _q2.default.defer();
					var ua = window.navigator.userAgent;

					var formatter = function formatter(token) {
						return token ? token.split('_')[0] : '';
					};

					//优先从cookie里读取token (wap、去啊、手淘、钱包8.5ios、钱包8.6android)
					var token = this.getCookie(this.TOKEN_KEY);

					if (token) {
						deferred.resolve(formatter(token));

						//cookie不可用，借助桥拿token
					} else {
							//运行环境
							var container = undefined;
							//钱包无域
							if (this.container.isAlipay) {
								container = 'alipay';
							}

							switch (container) {
								case 'alipay':
									var _alipay_getMtopToken = function _alipay_getMtopToken() {
										AlipayJSBridge.call('getMtopToken', {
											domain: domain
										}, function (json) {
											deferred.resolve(formatter(json.token));
										});
									};
									alipayCall(_alipay_getMtopToken);
									break;
								default:
									deferred.resolve(formatter(null));
							}
						}

					return deferred.promise;
				},
				send: function send(url, callback, options) {
					var self = this;

					var uid = options.uid;

					/**
      * status：uninitialized, loading, loaded, interactive, complete
      * (未初始化)： (XMLHttpRequest)对象已经创建，但还没有调用open()方法。
      * (载入)：已经调用open() 方法，但尚未发送请求。
      * 暂时没有 -- (载入完成)： 请求已经发送完成。
      * 暂时没有 -- (交互)：可以接收到部分响应数据。
      * (完成)：已经接收到了全部数据，并且连接已经关闭。
      * */
					requestHistory[uid].status = 'uninitialized';
					var script = document.createElement('script');

					var callbackName = 'mtopjsonp' + jsonpInc++,
					    timeoutid = setTimeout(function () {
						cleanup('TIMEOUT');
					}, options.timeout);

					window[callbackName] = function () {
						//航旅棱镜数据埋点统一处理
						if (arguments[0] && arguments[0].data) {
							configPrism(arguments[0].data);
						}

						//MTOP性能统计
						options && sendPerformanceLog(options, 'success');
						//mtop已返回，清除超时处理
						timeoutid && clearTimeout(timeoutid);

						// 状态修改为完成
						requestHistory[uid].status = 'complete';
						requestHistory[uid].abort = function () {};

						//是否使用sufei防爬刷，默认false
						if (options && options.useSufei) {
							fireEvent(document, 'sufei:validateData', arguments);
						} else {
							fireEvent(document, 'sufei:noNeedToValidate', arguments);
						}
					};

					//请求未成功返回
					var cleanup = function cleanup(type) {
						// 若已经完成，则直接跳出
						if (requestHistory[uid].status === 'complete') {
							return;
						}

						//适配器,按照新的tracker规范转换。MTOP性能
						options && sendPerformanceLog(options, type);

						timeoutid && clearTimeout(timeoutid);
						if (script && script.parentNode) {
							script.parentNode.removeChild(script);
						}

						// 将状态置为完成
						requestHistory[uid].status = 'complete';
						requestHistory[uid].abort = function () {};

						// 异常code::msg
						var ret = '抱歉, 服务器忙, 请稍后重试';
						switch (type) {
							case 'TIMEOUT':
							case 'ACTIVE_ABORT':
							case 'ABORT':
								ret = type + '::' + ret;
								break;
							default:
								ret = 'ERROR' + '::' + ret;
						}

						//手动完成请求callback
						window[callbackName](Object.assign({}, options, {
							ret: [ret]
						}));

						window[callbackName] = function () {
							delete window[callbackName];
						};
					};

					// 添加主动abort请求的方法
					requestHistory[uid].abort = function () {
						cleanup('ACTIVE_ABORT');
					};

					self.beginMtopSend = new Date();

					_tracker2.default.timelineStart && _tracker2.default.timelineStart(options.api); //MTOP是串行,可以保证这里的参数是唯一,能和timelineEnd对应,如果要支持并行,此处建议增加jsonpInc来保证唯一

					//更新request的状态
					requestHistory[uid].status = 'loading';

					//alitrip 使用native代理mtop请求
					if (url.useNative && this.container.isAlitrip && this.useNative(options)) {
						console.log('alitrip');
						var params = url,
						    needLogin = params.needLogin,
						    protocal = needLogin ? 'biz/mtop_ecode_sign' : 'biz/mtop_normal_sign';

						//设置成功失败回调
						params.successCallback = function (data) {
							data = typeof data === 'string' ? JSON.parse(data) : data;
							window[callbackName] && window[callbackName].call(this, data);
						};

						params.failCallback = function (data) {
							data = typeof data === 'string' ? JSON.parse(data) : data;
							window[callbackName] && window[callbackName].call(this, data);
						};

						// 标识是h5通过native发的参数
						if (params['data']) {
							params['data']['_platform_from_h5'] = true;
						}

						//向客户端发送协议
						_jsbridge2.default.pushBack('native:', protocal, params);
						return 'alitrip';
					}

					//钱包version>=9.0 使用native代理mtop请求
					if (url.useNative && this.container.isAlipay && this.useNative(options)) {
						console.log('alipay');
						//钱包下hack未登录问题（主要针对未绑定淘宝账户的用户）
						if (url.needLogin && !mtop.isLogin()) {
							self.goLogin();
							return;
						}

						var _alipay_mtop = function _alipay_mtop() {
							//var _options = S.clone(url);
							var _options = Object.assign({}, url);

							//适配钱包mtop配置
							_options.apiName = _options.api;
							delete _options.api;
							_options.apiVersion = _options.v;
							delete _options.v;
							_options.needEcodeSign = _options.needLogin;
							delete _options.needLogin;
							//人机识别
							_options.needWua = _options.issec > 0;
							_options.isNeedWua = _options.issec > 0;

							AlipayJSBridge.call('mtop', _options, function (data) {
								data = typeof data === 'string' ? JSON.parse(data) : data;
								window[callbackName] && window[callbackName].call(this, data);
							});
						};
						alipayCall(_alipay_mtop);
						return 'alipay';
					}

					//手淘(IOS:version>=5.2.9，Android:version>=5.2.12) 使用native代理mtop请求
					//淘宝和天猫都用的WindVane
					if (url.useNative && (this.container.isTaobao || this.container.isTmall) && this.useNative(options)) {
						console.log('taobao');
						//var params = S.clone(url);
						var params = Object.assign({}, url);

						//返回的数据类型(适配mtop sdk)
						if (params.type === 'originaljsonp') {
							params.type = 'originaljson';
						}
						if (params.type === 'jsonp') {
							params.type = 'json';
						}
						//请求方式
						if (params.method === 'post') {
							params.post = 1;
						}
						//业务参数
						params.param = url.data;
						delete params.data;
						//签名
						params.ecode = params.needLogin ? '1' : '0';
						//请求的 API 需要登录，自动登录，登录失败则拉起登录界面
						if (params.needLogin) {
							params.sessionOption = 'AutoLoginAndManualLogin';
						}
						delete params.needLogin;
						//人机识别(黑匣子)
						if (params.issec) {
							params.isSec = params.issec;
						}

						//发送网络请求的超时时间（毫秒），如果在指定时间内网络请求没有回来，则自动走缓存；如果没有缓存，则返回超时错误。-1 或不传表示不设置超时，总是会等待网络请求。
						params.timer = params.timeout;

						//向客户端发送协议
						var _callback = function _callback(data) {
							data = typeof data === 'string' ? JSON.parse(data) : data;
							window[callbackName] && window[callbackName].call(this, data);
						};
						window.WindVane.call('MtopWVPlugin', 'send', params, function (data) {
							_callback(data);
						}, function (data) {
							_callback(data);
						});
						return 'windVane';
					}

					if (/json$/i.test(options.type)) {
						console.log('h5 ajax json');

						var xhr = new XMLHttpRequest();

						xhr.addEventListener('readystatechange', function () {
							//readyState五个状态:0->未连接;1->打开连接;2->发送请求;3->交互;4->完成交互，接收响应
							if (xhr.readyState == 4) {
								var status = xhr.status;
								//response的HTTP状态码:1XX->服务器收到请求，需要继续处理;2XX->请求成功;3XX->重定向;4XX->客户端错误;5XX->服务器错误
								if (200 <= status && status < 300 || status == 304) {
									var result = xhr.responseText;

									try {
										result = /^\s*$/.test(result) ? {} : JSON.parse(result);
									} catch (e) {
										console.log(e);
									}

									xhr = null;
									window[callbackName](result);
								} else {
									//mtop post异常打点跟踪
									(function () {
										try {
											_tracker2.default.log(options.api, {
												errorName: 'MTOP_ERROR::ajax',
												errorCode: xhr.status,
												errorMesage: 'response的HTTP状态码异常',
												errorDetail: options.api,
												v: options.v,
												method: options.method,
												useNative: options.useNative
											}, null, 'mtop');
										} catch (e) {
											console.log(e);
										}
									})();
								}
							}
						}, false);
						xhr.addEventListener('error', function () {
							cleanup('ABORT');
						}, false);
						xhr.open(options.method, url, true);
						//发送带凭据的请求,解决Ajax跨域
						xhr.withCredentials = true;
						xhr.setRequestHeader('Accept', 'application/json');
						xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
						xhr.send('data=' + options.data);
					} else {
						console.log('h5 jsonp');

						script.src = url.replace('callback=jsonpCallback', 'callback=' + callbackName);
						script.sync = true;
						script.onerror = function () {
							cleanup('ABORT');
						};
						document.getElementsByTagName('head')[0].appendChild(script);
					}
				},

				md5: function () {
					var e = function e(_e, t) {
						return _e << t | _e >>> 32 - t;
					},
					    t = function t(e, _t) {
						var n, r, i, s, o;
						return i = e & 2147483648, s = _t & 2147483648, n = e & 1073741824, r = _t & 1073741824, o = (e & 1073741823) + (_t & 1073741823), n & r ? o ^ 2147483648 ^ i ^ s : n | r ? o & 1073741824 ? o ^ 3221225472 ^ i ^ s : o ^ 1073741824 ^ i ^ s : o ^ i ^ s;
					},
					    n = function n(e, t, _n) {
						return e & t | ~e & _n;
					},
					    r = function r(e, t, n) {
						return e & n | t & ~n;
					},
					    i = function i(e, t, n) {
						return e ^ t ^ n;
					},
					    s = function s(e, t, n) {
						return t ^ (e | ~n);
					},
					    o = function o(r, i, s, _o, u, a, f) {
						return r = t(r, t(t(n(i, s, _o), u), f)), t(e(r, a), i);
					},
					    u = function u(n, i, s, o, _u, a, f) {
						return n = t(n, t(t(r(i, s, o), _u), f)), t(e(n, a), i);
					},
					    a = function a(n, r, s, o, u, _a, f) {
						return n = t(n, t(t(i(r, s, o), u), f)), t(e(n, _a), r);
					},
					    f = function f(n, r, i, o, u, a, _f) {
						return n = t(n, t(t(s(r, i, o), u), _f)), t(e(n, a), r);
					},
					    l = function l(e) {
						var t,
						    n = e.length,
						    r = n + 8,
						    i = (r - r % 64) / 64,
						    s = (i + 1) * 16,
						    o = new Array(s - 1),
						    u = 0,
						    a = 0;
						while (a < n) {
							t = (a - a % 4) / 4, u = a % 4 * 8, o[t] = o[t] | e.charCodeAt(a) << u, a++;
						}return t = (a - a % 4) / 4, u = a % 4 * 8, o[t] = o[t] | 128 << u, o[s - 2] = n << 3, o[s - 1] = n >>> 29, o;
					},
					    c = function c(e) {
						var t = "",
						    n = "",
						    r,
						    i;
						for (i = 0; i <= 3; i++) {
							r = e >>> i * 8 & 255, n = "0" + r.toString(16), t += n.substr(n.length - 2, 2);
						}return t;
					},
					    h = function h(e) {
						e = e.replace(/\r\n/g, "\n");
						var t = "";
						for (var n = 0; n < e.length; n++) {
							var r = e.charCodeAt(n);
							r < 128 ? t += String.fromCharCode(r) : r > 127 && r < 2048 ? (t += String.fromCharCode(r >> 6 | 192), t += String.fromCharCode(r & 63 | 128)) : (t += String.fromCharCode(r >> 12 | 224), t += String.fromCharCode(r >> 6 & 63 | 128), t += String.fromCharCode(r & 63 | 128));
						}
						return t;
					},
					    p = function p(e) {
						var n = [],
						    r,
						    i,
						    s,
						    p,
						    d,
						    v,
						    m,
						    g,
						    y,
						    b = 7,
						    w = 12,
						    E = 17,
						    S = 22,
						    x = 5,
						    T = 9,
						    N = 14,
						    C = 20,
						    k = 4,
						    L = 11,
						    A = 16,
						    O = 23,
						    M = 6,
						    _ = 10,
						    D = 15,
						    P = 21;
						e = h(e), n = l(e), v = 1732584193, m = 4023233417, g = 2562383102, y = 271733878;
						for (r = 0; r < n.length; r += 16) {
							i = v, s = m, p = g, d = y, v = o(v, m, g, y, n[r + 0], b, 3614090360), y = o(y, v, m, g, n[r + 1], w, 3905402710), g = o(g, y, v, m, n[r + 2], E, 606105819), m = o(m, g, y, v, n[r + 3], S, 3250441966), v = o(v, m, g, y, n[r + 4], b, 4118548399), y = o(y, v, m, g, n[r + 5], w, 1200080426), g = o(g, y, v, m, n[r + 6], E, 2821735955), m = o(m, g, y, v, n[r + 7], S, 4249261313), v = o(v, m, g, y, n[r + 8], b, 1770035416), y = o(y, v, m, g, n[r + 9], w, 2336552879), g = o(g, y, v, m, n[r + 10], E, 4294925233), m = o(m, g, y, v, n[r + 11], S, 2304563134), v = o(v, m, g, y, n[r + 12], b, 1804603682), y = o(y, v, m, g, n[r + 13], w, 4254626195), g = o(g, y, v, m, n[r + 14], E, 2792965006), m = o(m, g, y, v, n[r + 15], S, 1236535329), v = u(v, m, g, y, n[r + 1], x, 4129170786), y = u(y, v, m, g, n[r + 6], T, 3225465664), g = u(g, y, v, m, n[r + 11], N, 643717713), m = u(m, g, y, v, n[r + 0], C, 3921069994), v = u(v, m, g, y, n[r + 5], x, 3593408605), y = u(y, v, m, g, n[r + 10], T, 38016083), g = u(g, y, v, m, n[r + 15], N, 3634488961), m = u(m, g, y, v, n[r + 4], C, 3889429448), v = u(v, m, g, y, n[r + 9], x, 568446438), y = u(y, v, m, g, n[r + 14], T, 3275163606), g = u(g, y, v, m, n[r + 3], N, 4107603335), m = u(m, g, y, v, n[r + 8], C, 1163531501), v = u(v, m, g, y, n[r + 13], x, 2850285829), y = u(y, v, m, g, n[r + 2], T, 4243563512), g = u(g, y, v, m, n[r + 7], N, 1735328473), m = u(m, g, y, v, n[r + 12], C, 2368359562), v = a(v, m, g, y, n[r + 5], k, 4294588738), y = a(y, v, m, g, n[r + 8], L, 2272392833), g = a(g, y, v, m, n[r + 11], A, 1839030562), m = a(m, g, y, v, n[r + 14], O, 4259657740), v = a(v, m, g, y, n[r + 1], k, 2763975236), y = a(y, v, m, g, n[r + 4], L, 1272893353), g = a(g, y, v, m, n[r + 7], A, 4139469664), m = a(m, g, y, v, n[r + 10], O, 3200236656), v = a(v, m, g, y, n[r + 13], k, 681279174), y = a(y, v, m, g, n[r + 0], L, 3936430074), g = a(g, y, v, m, n[r + 3], A, 3572445317), m = a(m, g, y, v, n[r + 6], O, 76029189), v = a(v, m, g, y, n[r + 9], k, 3654602809), y = a(y, v, m, g, n[r + 12], L, 3873151461), g = a(g, y, v, m, n[r + 15], A, 530742520), m = a(m, g, y, v, n[r + 2], O, 3299628645), v = f(v, m, g, y, n[r + 0], M, 4096336452), y = f(y, v, m, g, n[r + 7], _, 1126891415), g = f(g, y, v, m, n[r + 14], D, 2878612391), m = f(m, g, y, v, n[r + 5], P, 4237533241), v = f(v, m, g, y, n[r + 12], M, 1700485571), y = f(y, v, m, g, n[r + 3], _, 2399980690), g = f(g, y, v, m, n[r + 10], D, 4293915773), m = f(m, g, y, v, n[r + 1], P, 2240044497), v = f(v, m, g, y, n[r + 8], M, 1873313359), y = f(y, v, m, g, n[r + 15], _, 4264355552), g = f(g, y, v, m, n[r + 6], D, 2734768916), m = f(m, g, y, v, n[r + 13], P, 1309151649), v = f(v, m, g, y, n[r + 4], M, 4149444226), y = f(y, v, m, g, n[r + 11], _, 3174756917), g = f(g, y, v, m, n[r + 2], D, 718787259), m = f(m, g, y, v, n[r + 9], P, 3951481745), v = t(v, i), m = t(m, s), g = t(g, p), y = t(y, d);
						}var H = c(v) + c(m) + c(g) + c(y);
						return H.toLowerCase();
					};
					return p;
				}()
			};

			//result 标准化处理
			var resultHandler = function resultHandler(result) {
				result = result || {};
				//规范服务端返回结果，如返回格式有误，抛出异常
				try {
					var ret = result.ret[0].split('::'),
					    data = result.data,
					    code = ret[0],
					    message = ret[1] && ret[1].split('##').pop() || '';
				} catch (e) {
					console.log(e);

					return {
						//返回状态码
						code: 'FAIL_RET_DATA_ERROR',
						//返回状态，如'success'、'warn'、'failed'
						status: 'FAIL_RET_DATA_ERROR',
						//局限当前返回，便于业务逻辑处理
						isSuccess: false,
						//明文，对用户可视
						message: '请求异常',
						//返回数据
						data: null
					};
				}

				//TODO,用code码与status标记状态更通用，便于状态扩展
				return {
					api: result.api,
					v: result.v,
					//返回状态码
					code: code,
					//返回状态，如'success'、'warn'、'failed'
					status: code,
					//局限当前返回，便于业务逻辑处理
					isSuccess: code === 'SUCCESS',
					//明文，对用户可视
					message: message,
					//返回数据
					data: data
				};
			};

			/**
    * 全局埋点处理逻辑,如果有LK,放入全局变量,埋点请求均带上此值
    * @param data
    */
			function configPrism(data) {
				if (typeof data._prism_lk !== 'undefined') {
					window._prism_lk = data._prism_lk;
				}
			}

			/**
    * 请求MTOP时,如果有_lk的埋点,则带上
    * @param data
    * @returns {*}
    */
			function insertPrism(data) {
				if (typeof window._prism_lk !== 'undefined') {
					data = data || {};
					data._prism_lk = JSON.stringify(window._prism_lk);
				}
				return data;
			}
			/**
    * 请求MTOP时,带上前端H5版本号,方便日志分析
    * @param data
    */
			function insertProjVersion(data) {
				data = data || {};
				data.h5Version = PROJECT_VERSION;
				return data;
			}
			var mtop = {

				Util: Util,

				name: 'h5ApiUpdate.do',

				/**
     * 保存所有历史请求信息
     * */
				history: requestHistory,

				/**
     * 请求接口服务，返回promise对象
     * @param options
     * @returns {promise|*|defer.promise|Q.promise}
     */
				request: function request(options, $q) {
					$q = $q || _q2.default;
					var deferred = $q.defer();

					//mtop接口业务相关配置
					var api = options.api || options.url,
					    v = options.v || options.version,
					   

					//业务参数
					data = options.data || {},
					   

					//mtop的相关配置
					params = Object.assign({}, options.params || {});

					//默认使用native代理mtop请求（native的SPDY比http1.1性能好很多，目前webView http2.0未启用）
					params.useNative = params.useNative === undefined ? true : params.useNative;

					//暂无notify状态跟踪
					var request = this.getApi(api, v, data, params, function (result) {
						var _result = resultHandler(result);

						if (_result.isSuccess) {
							deferred.resolve(_result);

							//返回异常
						} else {
								deferred.reject(_result);
							}

						//请求异常
					}, function (result) {
						var _result = resultHandler(result);

						deferred.reject(_result);
					});

					// 将request对象挂载到promise上
					deferred.promise.request = request;

					return deferred.promise;
				},
				//手动取消所有请求，慎用，会取消所有的请求
				abortAll: function abortAll() {
					for (var r in requestHistory) {
						if (requestHistory[r].status !== 'complete') {
							requestHistory[r].abort();
						}
					}
				},
				getApi: function getApi(apiName, apiVersion, data, params, success, failture) {
					params = params || {};

					data = insertPrism(data);
					data = insertProjVersion(data);

					var options = {
						api: apiName,
						v: apiVersion,
						data: data,
						// 设置options.uid
						uid: randomUID(),
						//配置数据返回类型
						type: 'originaljsonp',
						//请求类型，默认'get'，支持'post'
						method: 'get',
						//默认使用native代理mtop请求（native的SPDY比http1.1性能好很多，目前webView http2.0未启用）
						useNative: true,
						//针对App定制化配置是否代理(钱包与手淘默认不代理)
						alipay: false,
						taobao: false,
						alitrip: true,
						//等待mtop请求返回阈值(超时设置)，默认20秒。目前mtop平台接口超时设置为15秒
						timeout: 20000
					};
					Object.assign(options, params);

					/*------------------------------------*\
      # 将每次请求的信息保存下来
      \*------------------------------------*/
					var request = {
						// todo: 可以把一个mtop请求的timeline都保存在这里，在complete的时候再发送埋点
						timeline: {
							startTime: +new Date() // 调用mtop的时间
						},
						uid: options.uid
					};

					requestHistory[options.uid] = request;

					Util.request(options, success, failture);

					return request;
				},
				//是否登录，同步方法，在cookie未种上的情况下登陆状态可能有误
				//用户信息相关cookie会在mtop或服务端应用请求返回时种上
				isLogin: function isLogin() {
					return !!this.getNickFromCookie();
				},
				//是否登陆，异步方法，请尽量使用该方法获取登陆态
				isLoginAsync: function () {
					//以下三个参数配合mtop.loginAsync方法使用，主要用于H5页面异步同步登陆态
					//首次请求生成的promise
					var loginAsyncDeferred = _q2.default.defer();
					//异步登陆信息回调函数队列
					var isLoginArray = [];
					//标志异步登陆信息是否已刷新完成
					var isLoginRefresh = false;

					return function (callback, context) {
						var t = this;
						//已完成登陆态同步、所处域名非alitrip 情况下，不作登陆态同步操作
						if (isLoginRefresh || location.href.indexOf('.alitrip.') == -1 || _jsbridge2.default.isAlitrip) {
							callback && callback.call(context || t, t.isLogin());
							loginAsyncDeferred.resolve(t.isLogin());
						} else {
							//第一次调用
							if (!isLoginArray.length) {
								window.__loginAsync = function (status) {
									isLoginRefresh = true;
									//S.each(isLoginArray, function (item) {
									//  item.callback && item.callback.call(item.context || t, t.isLogin(), status);
									//  loginAsyncDeferred.resolve(t.isLogin(), status);
									//});
									isLoginArray.forEach(function (item) {
										item.callback && item.callback.call(item.context || t, t.isLogin(), status);
										loginAsyncDeferred.resolve(t.isLogin(), status);
									});
								};

								var script = document.createElement('script');
								script.src = 'https://login.taobao.com/jump?target=https%3a%2f%2fmarket.alitrip.com%2fmarkets%2falitrip%2falitrip_tbpass_jump';
								script.sync = true;
								script.onerror = function () {
									window.__loginAsync.call(t, 'error');
								};
								document.getElementsByTagName('head')[0].appendChild(script);
							}

							isLoginArray.push({
								callback: callback,
								context: context
							});
						}

						return loginAsyncDeferred.promise;
					};
				}(),
				//获取用户名
				getNickFromCookie: function getNickFromCookie() {
					var nick = '',
					   

					//PC与无线会统一使用_nk_ @水寒（去啊app内登录后，会将_nk_ || _w_tb_nick信息植入cookie）
					//h5.m.taobao.com（去啊app内登录后，会将_w_tb_nick信息植入cookie）
					wapnick = Util.getCookie('_w_tb_nick'),
					   

					//taobao.com
					tbnick = Util.getCookie('_nk_') || Util.getCookie('snk');

					if (wapnick && wapnick.length > 0 && wapnick != 'null') {
						// 中文会encode，需要decode
						nick = decodeURIComponent(wapnick);
					} else if (tbnick && tbnick.length > 0 && tbnick != 'null') {
						// todo: ECMAScript v3 已从标准中删除了 unescape() 函数，并反对使用它，因此应该用 decodeURI() 和 decodeURIComponent() 取而代之。
						nick = unescape(unescape(tbnick).replace(/\\u/g, '%u'));
					}

					return nick;
				},
				/**
     * @description 新-获取用户名
     * @returns {promise|*|defer.promise|Q.promise}
     */
				getNick: function getNick() {
					var self = this,
					    deferred = _q2.default.defer();

					if (Util.container.isAlipay) {
						var _alipay_getConfig = function _alipay_getConfig() {
							//优先从cookie取（钱包9.5后有域cookie可用）
							var nick = self.getNickFromCookie();
							if (nick) {
								deferred.resolve(nick);
							} else {
								//钱包获取uuid，version >= 8.3
								AlipayJSBridge.call('getConfig', {
									configKeys: ['uuid']
								}, function (result) {
									try {
										deferred.resolve(result.data.uuid);
									} catch (e) {
										console.log(e);
										deferred.reject('AlipayJSBridge get uuid failed.');
									}
								});
							}
						};
						alipayCall(_alipay_getConfig);
					} else {
						var nick = '',
						   

						//h5.m.taobao.com
						wapnick = Util.getCookie('_w_tb_nick'),
						   

						//taobao.com
						tbnick = Util.getCookie('_nk_') || Util.getCookie('snk');

						if (wapnick && wapnick.length > 0 && wapnick != 'null') {
							// 中文会encode，需要decode
							nick = decodeURIComponent(wapnick);
						} else if (tbnick && tbnick.length > 0 && tbnick != 'null') {
							nick = unescape(unescape(tbnick).replace(/\\u/g, '%u'));
						}

						if (nick) {
							deferred.resolve(nick);
						} else {
							deferred.reject(null);
						}
					}

					return deferred.promise;
				},
				/**
     * @method loginedRequest
     * @param {Object} apiParam   mtop接口的入参
     * @param {String} apiParam.api  对应的mtop api
     * @param {String} apiParam.v    api版本
     * @param {Object} apiParam.data   mtop接口的入参
     * @param {Object} apiParam.extParam   额外的参数
     * @param {Object} callback 回调对象
     * @param {Function} callback.succ 成功的回调
     * @param {Function} callback.fail 失败的回调
     * @param {Function} callback.beforeLogin  跳到登录前的回调
     * @see request
     */
				loginedRequest: function loginedRequest(apiParam, succ, fail, beforeLogin) {
					if (succ && typeof succ !== 'function') {
						beforeLogin = succ.beforeLogin;
						fail = succ.fail;
						succ = succ.succ;
					}

					var popLogin = function popLogin() {
						if (apiParam.retryed) {
							fail.call(null, {
								errcode: "NOT_LOGINED",
								message: "该页面需要登录，请刷新重试!"
							});
						} else {
							beforeLogin && beforeLogin.call();
							Util.goLogin();
						}
					};

					apiParam.useNative = typeof apiParam.useNative === 'undefined' ? true : apiParam.useNative;

					//如果需要
					if (apiParam.useNative && Util.useNative(options)) {
						apiParam.needLogin = true;
					} else {

						if (!this.isLogin()) {
							popLogin();
							return;
						}
					}

					//等待mtop请求返回阀值(超时设置)，默认20秒。目前mtop平台接口超时设置为15秒
					apiParam.timeout = apiParam.timeout || 20000;

					Util.request(apiParam, succ, fail);
				},
				executeCall: function executeCall() {
					if (!requestQueue.length) {
						return;
					}
					var args = requestQueue.shift();
					Util.sendRequest.apply(Util, args);
				},
				goLogin: Util.goLogin,
				version: "0.2.21"
			};

			//默认同步一次登陆态
			mtop.isLoginAsync();

			module.exports = mtop;

			if (window.KISSY && KISSY.add) {
				KISSY.add('mtop/index', function () {
					return mtop;
				});
			}

			/***/
		},
		/* 2 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

			/***/
		},
		/* 3 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

			/***/
		},
		/* 4 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

			/***/
		},
		/* 5 */
		/***/function (module, exports) {

			/*** IMPORTS FROM imports-loader ***/
			(function () {

				//pointman 2.0.0
				(function (global, undefined) {
					'use strict';
					// Avoid conflicting when `pointman.js` is loaded multiple times

					if (global.pointman) {
						return;
					}

					var pointman = global.pointman = {
						version: '2.0.0'
					};

					var data = pointman.data = {};

					/**
      * util-lang.js - The minimal language enhancement
      */

					function isType(type) {
						return function (obj) {
							return {}.toString.call(obj) == '[object ' + type + ']';
						};
					}

					var isObject = isType('Object');
					var isString = isType('String');
					var isArray = Array.isArray || isType('Array');
					var isFunction = isType('Function');

					var _cid = 0;

					function cid() {
						return _cid++;
					}

					/**
      * util-events.js - The minimal events support
      */

					var events = data.events = {};

					// Bind event
					pointman.on = function (name, callback) {
						var list = events[name] || (events[name] = []);
						list.push(callback);
						return pointman;
					};

					// Remove event. If `callback` is undefined, remove all callbacks for the
					// event. If `event` and `callback` are both undefined, remove all callbacks
					// for all events
					pointman.off = function (name, callback) {
						// Remove *all* events
						if (!(name || callback)) {
							events = data.events = {};
							return pointman;
						}

						var list = events[name];
						if (list) {
							if (callback) {
								for (var i = list.length - 1; i >= 0; i--) {
									if (list[i] === callback) {
										list.splice(i, 1);
									}
								}
							} else {
								delete events[name];
							}
						}

						return pointman;
					};

					/**
      * util-path.js - The utilities for operating path such as id, uri
      */

					var DIRNAME_RE = /[^?#]*\//;

					var DOT_RE = /\/\.\//g;
					var DOUBLE_DOT_RE = /\/[^/]+\/\.\.\//;
					var MULTI_SLASH_RE = /([^:/])\/+\//g;

					// Extract the directory portion of a path
					// dirname('a/b/c.js?t=123#xx/zz') ==> 'a/b/'
					// ref: http://jsperf.com/regex-vs-split/2
					function dirname(path) {
						return path.match(DIRNAME_RE)[0];
					}

					// Canonicalize a path
					// realpath('http://test.com/a//./b/../c') ==> 'http://test.com/a/c'
					function realpath(path) {
						// /a/b/./c/./d ==> /a/b/c/d
						path = path.replace(DOT_RE, '/');

						/*
        @author wh1100717
        a//b/c ==> a/b/c
        a///b/////c ==> a/b/c
        DOUBLE_DOT_RE matches a/b/c//../d path correctly only if replace // with / first
      */
						path = path.replace(MULTI_SLASH_RE, '$1/');

						// a/b/c/../../d  ==>  a/b/../d  ==>  a/d
						while (path.match(DOUBLE_DOT_RE)) {
							path = path.replace(DOUBLE_DOT_RE, '/');
						}

						return path;
					}

					// Normalize an id
					// normalize('path/to/a') ==> 'path/to/a.js'
					// NOTICE: substring is faster than negative slice and RegExp
					function normalize(path) {
						var last = path.length - 1;
						var lastC = path.charAt(last);

						// If the uri ends with `#`, just return it without '#'
						if (lastC === '#') {
							return path.substring(0, last);
						}

						return path.substring(last - 2) === '.js' || path.indexOf('?') > 0 || lastC === '/' ? path : path + '.js';
					}

					var PATHS_RE = /^([^/:]+)(\/.+)$/;
					var VARS_RE = /{([^{]+)}/g;

					function parseAlias(id) {
						var alias = data.alias;
						return alias && isString(alias[id]) ? alias[id] : id;
					}

					function parsePaths(id) {
						var paths = data.paths;
						var m;

						if (paths && (m = id.match(PATHS_RE)) && isString(paths[m[1]])) {
							id = paths[m[1]] + m[2];
						}

						return id;
					}

					function parseVars(id) {
						var vars = data.vars;

						if (vars && id.indexOf('{') > -1) {
							id = id.replace(VARS_RE, function (m, key) {
								return isString(vars[key]) ? vars[key] : m;
							});
						}

						return id;
					}

					function parseMap(uri) {
						var map = data.map;
						var ret = uri;

						if (map) {
							for (var i = 0, len = map.length; i < len; i++) {
								var rule = map[i];

								ret = isFunction(rule) ? rule(uri) || uri : uri.replace(rule[0], rule[1]);

								// Only apply the first matched rule
								if (ret !== uri) {
									break;
								}
							}
						}

						return ret;
					}

					var ABSOLUTE_RE = /^\/\/.|:\//;
					var ROOT_DIR_RE = /^.*?\/\/.*?\//;

					function addBase(id, refUri) {
						var ret;
						var first = id.charAt(0);

						// Absolute
						if (ABSOLUTE_RE.test(id)) {
							ret = id;
						}
						// Relative
						else if (first === '.') {
								ret = realpath((refUri ? dirname(refUri) : data.cwd) + id);
							}
							// Root
							else if (first === '/') {
									var m = data.cwd.match(ROOT_DIR_RE);
									ret = m ? m[0] + id.substring(1) : id;
								}
								// Top-level
								else {
										ret = data.base + id;
									}

						// Add default protocol when uri begins with '//'
						if (ret.indexOf('//') === 0) {
							ret = location.protocol + ret;
						}

						return ret;
					}

					function id2Uri(id, refUri) {
						if (!id) {
							return '';
						}

						id = parseAlias(id);
						id = parsePaths(id);
						id = parseVars(id);
						id = normalize(id);

						var uri = addBase(id, refUri);
						uri = parseMap(uri);

						return uri;
					}

					var doc = document;
					var cwd = !location.href || location.href.indexOf('about:') === 0 ? '' : dirname(location.href);
					var scripts = doc.scripts;

					// Recommend to add `pointmannode` id for the `sea.js` script element
					var loaderScript = doc.getElementById('pointmannode') || scripts[scripts.length - 1];

					function getScriptAbsoluteSrc(node) {
						return node.hasAttribute ? // non-IE6/7
						node.src :
						// see http://msdn.microsoft.com/en-us/library/ms536429(VS.85).aspx
						node.getAttribute('src', 4);
					}

					// When `sea.js` is inline, set loaderDir to current working directory
					var loaderDir = dirname(getScriptAbsoluteSrc(loaderScript) || cwd);

					// For Developers
					pointman.resolve = id2Uri;

					/**
      * util-request.js - The utilities for requesting script and style files
      * ref: tests/research/load-js-css/test.html
      */

					var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
					var baseElement = head.getElementsByTagName('base')[0];

					var currentlyAddingScript;
					var interactiveScript;

					function request(url, callback, charset) {
						var node = doc.createElement('script');

						if (charset) {
							var cs = isFunction(charset) ? charset(url) : charset;
							if (cs) {
								node.charset = cs;
							}
						}

						addOnload(node, callback, url);

						node.async = true;
						node.src = url;

						// For some cache cases in IE 6-8, the script executes IMMEDIATELY after
						// the end of the insert execution, so use `currentlyAddingScript` to
						// hold current node, for deriving url in `define` call
						currentlyAddingScript = node;

						// ref: #185 & http://dev.jquery.com/ticket/2709
						baseElement ? head.insertBefore(node, baseElement) : head.appendChild(node);

						currentlyAddingScript = null;
					}

					function addOnload(node, callback, url) {
						var supportOnload = 'onload' in node;

						function onload() {
							// Ensure only run once and handle memory leak in IE
							node.onload = node.onerror = node.onreadystatechange = null;

							// Remove the script to reduce memory leak
							if (!data.debug) {
								head.removeChild(node);
							}

							// Dereference the node
							node = null;

							callback();
						}

						if (supportOnload) {
							node.onload = onload;
							node.onerror = function () {
								onload();
							};
						} else {
							node.onreadystatechange = function () {
								if (/loaded|complete/.test(node.readyState)) {
									onload();
								}
							};
						}
					}

					function getCurrentScript() {
						if (currentlyAddingScript) {
							return currentlyAddingScript;
						}

						// For IE6-9 browsers, the script onload event may not fire right
						// after the script is evaluated. Kris Zyp found that it
						// could query the script nodes and the one that is in 'interactive'
						// mode indicates the current script
						// ref: http://goo.gl/JHfFW
						if (interactiveScript && interactiveScript.readyState === 'interactive') {
							return interactiveScript;
						}

						var scripts = head.getElementsByTagName('script');

						for (var i = scripts.length - 1; i >= 0; i--) {
							var script = scripts[i];
							if (script.readyState === 'interactive') {
								interactiveScript = script;
								return interactiveScript;
							}
						}
					}

					// For Developers
					pointman.request = request;

					/**
      * util-deps.js - The parser for dependencies
      * ref: tests/research/parse-dependencies/test.html
      */

					var REQUIRE_RE = /'(?:\\'|[^'])*'|'(?:\\'|[^'])*'|\/\*[\S\s]*?\*\/|\/(?:\\\/|[^\/\r\n])+\/(?=[^\/])|\/\/.*|\.\s*require|(?:^|[^$])\brequire\s*\(\s*([''])(.+?)\1\s*\)/g;
					var SLASH_RE = /\\\\/g;

					function parseDependencies(code) {
						var ret = [];

						code.replace(SLASH_RE, '').replace(REQUIRE_RE, function (m, m1, m2) {
							if (m2) {
								ret.push(m2);
							}
						});

						return ret;
					}

					/**
      * module.js - The core of module loader
      */

					var cachedMods = pointman.cache = {};
					var anonymousMeta;

					var fetchingList = {};
					var fetchedList = {};
					var callbackList = {};

					var STATUS = Module.STATUS = {
						// 1 - The `module.uri` is being fetched
						FETCHING: 1,
						// 2 - The meta data has been saved to cachedMods
						SAVED: 2,
						// 3 - The `module.dependencies` are being loaded
						LOADING: 3,
						// 4 - The module are ready to execute
						LOADED: 4,
						// 5 - The module is being executed
						EXECUTING: 5,
						// 6 - The `module.exports` is available
						EXECUTED: 6
					};

					function Module(uri, deps) {
						this.uri = uri;
						this.dependencies = deps || [];
						this.exports = null;
						this.status = 0;

						// Who depends on me
						this._waitings = {};

						// The number of unloaded dependencies
						this._remain = 0;
					}

					// Resolve module.dependencies
					Module.prototype.resolve = function () {
						var mod = this;
						var ids = mod.dependencies;
						var uris = [];

						for (var i = 0, len = ids.length; i < len; i++) {
							uris[i] = Module.resolve(ids[i], mod.uri);
						}
						return uris;
					};

					// Load module.dependencies and fire onload when all done
					Module.prototype.load = function () {
						var mod = this;

						// If the module is being loaded, just wait it onload call
						if (mod.status >= STATUS.LOADING) {
							return;
						}

						mod.status = STATUS.LOADING;

						// Emit `load` event for plugins such as combo plugin
						var uris = mod.resolve();

						var len = mod._remain = uris.length;
						var m;

						// Initialize modules and register waitings
						for (var i = 0; i < len; i++) {
							m = Module.get(uris[i]);

							if (m.status < STATUS.LOADED) {
								// Maybe duplicate: When module has dupliate dependency, it should be it's count, not 1
								m._waitings[mod.uri] = (m._waitings[mod.uri] || 0) + 1;
							} else {
								mod._remain--;
							}
						}

						if (mod._remain === 0) {
							mod.onload();
							return;
						}

						// Begin parallel loading
						var requestCache = {};

						for (i = 0; i < len; i++) {
							m = cachedMods[uris[i]];

							if (m.status < STATUS.FETCHING) {
								m.fetch(requestCache);
							} else if (m.status === STATUS.SAVED) {
								m.load();
							}
						}

						// Send all requests at last to avoid cache bug in IE6-9. Issues#808
						for (var requestUri in requestCache) {
							if (requestCache.hasOwnProperty(requestUri)) {
								requestCache[requestUri]();
							}
						}
					};

					// Call this method when module is loaded
					Module.prototype.onload = function () {
						var mod = this;
						mod.status = STATUS.LOADED;

						if (mod.callback) {
							mod.callback();
						}

						// Notify waiting modules to fire onload
						var waitings = mod._waitings;
						var uri, m;

						for (uri in waitings) {
							if (waitings.hasOwnProperty(uri)) {
								m = cachedMods[uri];
								m._remain -= waitings[uri];
								if (m._remain === 0) {
									m.onload();
								}
							}
						}

						// Reduce memory taken
						delete mod._waitings;
						delete mod._remain;
					};

					// Fetch a module
					Module.prototype.fetch = function (requestCache) {
						var mod = this;
						var uri = mod.uri;

						mod.status = STATUS.FETCHING;

						// Emit `fetch` event for plugins such as combo plugin
						var emitData = {
							uri: uri
						};
						var requestUri = emitData.requestUri || uri;

						// Empty uri or a non-CMD module
						if (!requestUri || fetchedList[requestUri]) {
							mod.load();
							return;
						}

						if (fetchingList[requestUri]) {
							callbackList[requestUri].push(mod);
							return;
						}

						fetchingList[requestUri] = true;
						callbackList[requestUri] = [mod];

						// Emit `request` event for plugins such as text plugin
						emitData = {
							uri: uri,
							requestUri: requestUri,
							onRequest: onRequest,
							charset: data.charset
						};

						if (!emitData.requested) {
							requestCache ? requestCache[emitData.requestUri] = sendRequest : sendRequest();
						}

						function sendRequest() {
							pointman.request(emitData.requestUri, emitData.onRequest, emitData.charset);
						}

						function onRequest() {
							delete fetchingList[requestUri];
							fetchedList[requestUri] = true;

							// Save meta data of anonymous module
							if (anonymousMeta) {
								Module.save(uri, anonymousMeta);
								anonymousMeta = null;
							}

							// Call callbacks
							var m,
							    mods = callbackList[requestUri];
							delete callbackList[requestUri];
							while (m = mods.shift()) {
								m.load();
							}
						}
					};

					// Execute a module
					Module.prototype.exec = function () {
						var mod = this;

						// When module is executed, DO NOT execute it again. When module
						// is being executed, just return `module.exports` too, for avoiding
						// circularly calling
						if (mod.status >= STATUS.EXECUTING) {
							return mod.exports;
						}

						mod.status = STATUS.EXECUTING;
						mod.config = data.modConfig && data.modConfig[mod.id];

						// Create require
						var uri = mod.uri;

						function require(id) {
							return Module.get(require.resolve(id)).exec();
						}

						require.resolve = function (id) {
							return Module.resolve(id, uri);
						};

						require.async = function (ids, callback) {
							Module.use(ids, callback, uri + '_async_' + cid());
							return require;
						};

						// Exec factory
						var factory = mod.factory;

						var exports = isFunction(factory) ? factory(require, mod.exports = {}, mod) : factory;

						if (exports === undefined) {
							exports = mod.exports;
						}

						// Reduce memory leak
						delete mod.factory;

						mod.exports = exports;
						mod.status = STATUS.EXECUTED;

						return exports;
					};

					// Resolve id to uri
					Module.resolve = function (id, refUri) {
						// Emit `resolve` event for plugins such as text plugin
						var emitData = {
							id: id,
							refUri: refUri
						};
						return emitData.uri || pointman.resolve(emitData.id, refUri);
					};

					// Define a module
					Module.define = function (id, deps, factory) {
						var argsLen = arguments.length;

						// define(factory)
						if (argsLen === 1) {
							factory = id;
							id = undefined;
						} else if (argsLen === 2) {
							factory = deps;

							// define(deps, factory)
							if (isArray(id)) {
								deps = id;
								id = undefined;
							}
							// define(id, factory)
							else {
									deps = undefined;
								}
						}

						// Parse dependencies according to the module factory code
						if (!isArray(deps) && isFunction(factory)) {
							deps = parseDependencies(factory.toString());
						}

						var meta = {
							id: id,
							uri: Module.resolve(id),
							deps: deps,
							factory: factory
						};

						// Try to derive uri in IE6-9 for anonymous modules
						if (!meta.uri && doc.attachEvent) {
							var script = getCurrentScript();

							if (script) {
								meta.uri = script.src;
							}

							// NOTE: If the id-deriving methods above is failed, then falls back
							// to use onload event to get the uri
						}

						// Emit `define` event, used in nocache plugin, pointman node version etc
						meta.uri ? Module.save(meta.uri, meta) :
						// Save information for 'saving' work in the script onload event
						anonymousMeta = meta;
					};

					// Save meta data to cachedMods
					Module.save = function (uri, meta) {
						var mod = Module.get(uri);

						// Do NOT override already saved modules
						if (mod.status < STATUS.SAVED) {
							mod.id = meta.id || uri;
							mod.dependencies = meta.deps || [];
							mod.factory = meta.factory;
							mod.status = STATUS.SAVED;
						};
					};

					// Get an existed module or create a new one
					Module.get = function (uri, deps) {
						return cachedMods[uri] || (cachedMods[uri] = new Module(uri, deps));
					};

					// Use function is equal to load a anonymous module
					Module.use = function (ids, callback, uri) {
						var mod = Module.get(uri, isArray(ids) ? ids : [ids]);

						mod.callback = function () {
							var exports = [];
							var uris = mod.resolve();

							for (var i = 0, len = uris.length; i < len; i++) {
								exports[i] = cachedMods[uris[i]].exec();
							}

							if (callback) {
								callback.apply(global, exports);
							}

							delete mod.callback;
						};

						mod.load();
					};

					// Public API

					pointman.use = function (ids, callback) {
						Module.use(ids, callback, data.cwd + '_use_' + cid());
						return pointman;
					};

					Module.define.cmd = {};
					pointman.define = Module.define;

					// For Developers

					pointman.Module = Module;
					data.fetchedList = fetchedList;
					data.cid = cid;

					pointman.require = function (id) {
						var mod = Module.get(Module.resolve(id));
						if (mod.status < STATUS.EXECUTING) {
							mod.onload();
							mod.exec();
						}
						return mod.exports;
					};

					/**
      * config.js - The configuration for the loader
      */

					// The root path to use for id2uri parsing
					data.base = loaderDir;

					// The loader directory
					data.dir = loaderDir;

					// The current working directory
					data.cwd = cwd;

					// The charset for requesting files
					data.charset = 'utf-8';

					//组件配置
					data.modConfig = {};
					//空闲时加载的组件列表
					var freeItem = [];

					function autoInitMod(modItems, callbackItem) {
						for (var i = 0; i < callbackItem.length; i++) {
							var mod = modItems[i];
							var configData = data.modConfig[mod];

							if (configData.config && callbackItem[i].init) {
								callbackItem[i].init(configData.config);
							}
						}
					}

					pointman.config = function (configData) {
						data.alias = configData.alias;
						data.base = configData.base;

						for (var k in configData.modules) {
							var loadAt = configData.modules[k].loadAt;

							data.modConfig[k] = configData.modules[k].config || {};

							//空闲时加载
							if (loadAt == 'free') {
								freeItem.push(k);
							}
						}
						if (freeItem.length > 0) {
							//window.load后加载freeItem中的文件
							if (window.addEventListener) {
								window.addEventListener('load', function (ev) {
									pointman.use(freeItem, function () {
										autoInitMod(freeItem, arguments);
									});
								}, false);
							} else {
								window.attachEvent('load', function (ev) {
									pointman.use(freeItem, function () {
										autoInitMod(freeItem, arguments);
									});
								});
							}
						}
					};
				})(this);

				(function () {
					pointman.config({
						modules: {
							sufei: {
								config: {
									app: 'tb-m',
									version: '2.0.0',
									style: '//g.alicdn.com/sd/pointman/app/mtop/sufei-tb-m.css'
								}
							}
						},
						base: '//g.alicdn.com/sd/pointman/js/'
					});
				})();

				pointman.define('mod/emit', function (require, exports, module) {
					'use strict';

					var emit = {};
					var events = {};

					// Bind event
					emit.on = function (name, callback) {
						var list = events[name] || (events[name] = []);
						list.push(callback);
						return emit;
					};

					// Remove event. If `callback` is undefined, remove all callbacks for the
					// event. If `event` and `callback` are both undefined, remove all callbacks
					// for all events
					emit.off = function (name, callback) {
						// Remove *all* events
						if (!(name || callback)) {
							events = {};
							return emit;
						}

						var list = events[name];
						if (list) {
							if (callback) {
								for (var i = list.length - 1; i >= 0; i--) {
									if (list[i] === callback) {
										list.splice(i, 1);
									}
								}
							} else {
								delete events[name];
							}
						}

						return emit;
					};

					// Emit event, firing all bound callbacks. Callbacks receive the same
					// arguments as `emit` does, apart from the event name
					emit.fire = function (name, data) {
						var list = events[name];

						if (list) {
							// Copy callback lists to prevent modification
							list = list.slice();

							// Execute event callbacks, use index because it's the faster.
							for (var i = 0, len = list.length; i < len; i++) {
								list[i](data);
							}
						}

						return emit;
					};

					module.exports = emit;
				});

				pointman.define('mod/messenger', function (require, exports, module) {
					'use strict';
					//消息分割符

					var msgSpliter = '@=_=@';
					//当前窗口
					var currentWin = null;
					//消息来源窗口
					var originWin = null;
					/*
      * 消息从哪里发过来
      * fromFrame: 消息从iframe发出
      * fromParent: 消息从父窗口发出
      */
					var msgTransfer = null;
					// 已注册事件
					var attachedEvents = [];
					var IE = {
						//Unique Id
						uid: 0,
						//Head Id 当前已处理到的 Id
						hid: -1,
						//发送消息队列
						q: [],
						//发送消息队列定时器
						tm: 0,
						/**
       * 发送跨域消息
       * @param {Object} target iframe.contentWindow|parent
       * @param {String} jsonStr
       */
						postMessage: function postMessage(target, jsonStr) {
							var uid = ++IE.uid;
							var q = IE.q;
							var item = {
								name: +new Date() + '' + uid + '^' + document.domain + '&' + jsonStr,
								uid: uid,
								target: target
							};
							q.push(item);
							if (!IE.tm) {
								IE.tm = setInterval(function () {
									var q = IE.q;
									if (q.length === 0 || q[0].uid <= IE.hid) {
										return;
									}
									var item = q[0];
									IE.hid = item.uid;
									item.target.name = item.name;
								}, 10);
							}
						},
						/**
       * window.name 监听方式
       * @param{Function}handler
       */
						ListenerMessage: function ListenerMessage(win, handler) {
							var lastName = '';
							var reName = /^(\d+?)\^(.+?)&(.*?)$/;

							function onNameChanged() {
								if (!win) {
									return false;
								} else {
									var name = win.name; //=window.name
									//如果和上次不一样，则获取新数据
									if (name !== lastName) {
										// 出队列，
										IE.q.shift();

										lastName = name;
										var ms = reName.exec(name);
										if (!ms) {
											return;
										}

										//模拟 postMessage event 参数
										handler && handler({
											origin: ms[2],
											data: ms[3]
										});
									}
								}
							}

							setInterval(onNameChanged, 10);
						}
					};

					function messageHandler(ev) {
						try {
							var data = ev.data.split(msgSpliter);
							var eventType = data[0];
							var msgData = data[1];
							//激活事件
							for (var i = 0, len = attachedEvents.length; i < len; i++) {
								if (attachedEvents[i].event === eventType) {
									attachedEvents[i].callback(msgData);
								}
							}
						} catch (e) {}
					}

					module.exports = {
						/*
       * 使用消息模块前需要先注册窗口，如果需要发送消息需要明确消息传递形式（obj.transfer）
       * obj.currentWin
       * obj.originWin
       * obj.msgTransfer
       */
						initListener: function initListener(obj) {
							//当前窗口
							currentWin = obj.currentWin;
							//消息来源窗口
							originWin = obj.originWin;
							//消息传递形式
							msgTransfer = obj.msgTransfer;

							if (currentWin && originWin && msgTransfer) {
								//在当前窗口上监听postmessage事件
								if (currentWin.postMessage) {
									if (currentWin.addEventListener) {
										currentWin.addEventListener('message', messageHandler, false);
									} else if (currentWin.attachEvent) {
										currentWin.attachEvent('onmessage', messageHandler);
									}
								} else {
									//始终确保在iframe上监听window.name变化
									if (msgTransfer == 'fromFrame') {
										//在父窗口中监听iframe发来的消息
										IE.ListenerMessage(originWin, messageHandler);
									} else {
										//在iframe中监听父窗口发送的消息
										IE.ListenerMessage(currentWin, messageHandler);
									}
								}
							}
						},
						//注册消息
						register: function register(event, callback) {
							attachedEvents.push({
								event: event,
								callback: callback
							});
						},
						/**
       * 发送消息.
       * @param {String} obj.type 消息类型.
       * @param {string} obj.content 消息内容
       */
						send: function send(obj) {
							//发给目标窗口的数据
							var postData = obj.type + msgSpliter + obj.content;

							if (currentWin && originWin && msgTransfer) {
								if (originWin.postMessage) {
									/*
          * initListener方法注册的是监听函数
          * 而发送消息与监听消息刚好相反，所以这里需要往originWin发送消息
          * 支持postmessage时往目标窗口发送消息
          */
									originWin.postMessage(postData, '*');
								} else {
									//始终确保写iframe的window.name
									if (msgTransfer == 'fromFrame') {
										//在父窗口中监听iframe发来的消息
										IE.postMessage(originWin, postData);
									} else {
										//在iframe中监听父窗口发送的消息
										IE.postMessage(currentWin, postData, '*');
									}
								}
							}
						}
					};
				});

				pointman.define('mod/sufei-kissymini-mtop', function (require, exports, module) {
					'use strict';

					var emit = require('mod/emit');
					var $ = null;

					function isType(type) {
						return function (obj) {
							return {}.toString.call(obj) == '[object ' + type + ']';
						};
					}
					var isObject = isType('Object');
					var isString = isType('String');

					/**
      * Dispatch an event with props to el
      */
					function fireEvent(el, eventType, props) {
						var event = document.createEvent('Events');
						var bubbles = true;
						if (props) {
							for (var name in props) {
								if (Object.hasOwnProperty.call(props, name)) {
									try {
										name === 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
									} catch (e) {}
								}
							}
						}
						event.initEvent(eventType, bubbles, true);
						el.dispatchEvent(event);
					}

					var sufeiMtop = function sufeiMtop() {
						this.cache = {
							//状态：(0)拦截中 -> (100)验证中 ->  (200)验证通过
							status: 0,
							//当前正在验证的请求
							currentRequest: null,
							//被拦截的队列
							queue: []
						};
					};

					sufeiMtop.prototype = {
						init: function init() {
							var self = this;

							//事件：验证通过后重发送请求（mtop中重新发送请求由mtop来处理）
							emit.on('event:resendRequest@sufei', function (data) {
								//KISSY.one(document).fire('sufei:validateDone', [data]);
								fireEvent(document, 'sufei:validateDone', [data]);
							});

							//监听消息
							document.addEventListener('sufei:validateData', function (data) {
								// KISSY.one(document).on('sufei:validateData', function(data){
								var result = data[0];
								if (result && isObject(result) && typeof result.ret !== 'undefined' && result.ret.join('') == 'RGV587_ERROR::SM') {
									emit.fire('event:showDialog@sufei', result.data.url);
								} else {
									//不需要校验
									// KISSY.one(document).fire('sufei:noNeedToValidate', data);
									fireEvent(document, 'sufei:noNeedToValidate', data);
								}
							});
						}
					};

					module.exports = sufeiMtop;
				});

				pointman.define('sufei', function (require, exports, module) {
					'use strict';
					//var SubMod = require('mod/sufei-seajs-jquery');

					var SubMod = require('mod/sufei-kissymini-mtop');
					var messenger = require('mod/messenger');
					//消息模块是否初始化
					var messengerHasInit = false;
					var emit = require('mod/emit');
					var doc = document;
					var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;

					var Sufei = function Sufei() {
						//可配置项
						this.config = {
							app: '',
							version: '',
							sufeiStyle: ''
						};
						//缓存
						this.cache = {
							//被拦截的请求队列
							queue: [],
							//dialog对象
							dialog: null
						};
					};

					Sufei.prototype = {
						init: function init() {
							var self = this;
							var configData = module.config;

							self.config.app = configData.app || '';
							self.config.version = configData.version || '';
							self.config.sufeiStyle = configData.style || '';

							//事件：显示验证对话框
							emit.on('event:showDialog@sufei', function (url) {
								if (!self.cache.dialog) {
									url += /\?/.test(url) ? '&' : '?';
									if (/tpl_redirect_url=http(s)?\:\/\/sec\.(([\w\d])*?\.)?taobao\.com\/query\.htm/.test(decodeURIComponent(url))) {
										url = url.replace('query.htm%3F', 'query.htm%3Fsufeiversion%3D' + self.config.version + '%26app%3D' + self.config.app + '%26');
									} else {
										url += 'sufeiversion=' + self.config.version + '&app=' + self.config.app;
									}
									//TODO 解决css版本问题
									self.loadCss(self.config.sufeiStyle, function () {
										self.createDialog(url);
									});
								} else {
									self.changeDialogStates({ state: 'visible' });
								}
							});

							new SubMod().init();
						},

						//加载CSS
						loadCss: function loadCss(url, callback) {
							var node = doc.createElement('link');
							node.chaarset = 'utf-8';
							node.rel = 'stylesheet';
							node.href = url;

							if ('onload' in node) {
								node.onload = function () {
									callback && callback();
								};
							} else {
								node.onreadystatechange = function () {
									if (/loaded|complete/.test(node.readyState)) {
										callback && callback();
									}
								};
							}

							head.appendChild(node);
						},

						//是否是ie6、7
						isOldBrower: function isOldBrower() {
							var b = doc.createElement('b');
							b.innerHTML = '<!--[if lte IE 7]><i></i><![endif]-->';
							return b.getElementsByTagName('i').length === 1;
						},

						//创建dialog
						createDialog: function createDialog(url) {
							var self = this;
							var dialog = document.createElement('div');
							var mask = null;
							var content = null;
							var maskIframe = null;
							var closeElement = null;
							//iframe窗口
							var frameWin = null;

							mask = doc.createElement('div');
							content = doc.createElement('div');
							closeElement = document.createElement('div');
							maskIframe = null;

							//可以通过sufeiStyle重定义dialog、mask风格
							if (self.config.app !== '') {
								dialog.className = 'sufei-dialog sufei-dialog-' + self.config.app;
							} else {
								dialog.className = 'sufei-dialog';
							}

							mask.className = 'sufei-dialog-mask';
							//IE6\7下为mask增加iframe
							if (self.isOldBrower()) {
								mask.innerHTML = '<iframe frameborder="none" src="javascript:\'\'"></iframe>';
							}

							//关闭按钮
							closeElement.className = 'sufei-dialog-close';
							closeElement.innerHTML = 'close';

							content.className = 'sufei-dialog-content';
							content.innerHTML = '<iframe id="sufei-dialog-content" frameborder="none" src="' + url + '""></iframe>';

							content.appendChild(closeElement);
							dialog.appendChild(mask);
							dialog.appendChild(content);
							doc.body.appendChild(dialog);

							frameWin = doc.getElementById('sufei-dialog-content').contentWindow;
							messenger.initListener({
								currentWin: window,
								originWin: frameWin,
								msgTransfer: 'fromFrame'
							});
							//标记消息模块已初始化
							messengerHasInit = true;

							//消息: 验证通过
							messenger.register('msg:validateSuccess@sufei', function (data) {
								//重新发送请求
								emit.fire('event:resendRequest@sufei', data);
								//隐藏dialog
								self.changeDialogStates({ state: 'hidden' });
								//消息: 重置验证码
								messenger.send({
									type: 'msg:resetCheckCode@sufei',
									content: ''
								});
							});

							//绑定关闭事件
							if (closeElement.addEventListener) {
								closeElement.addEventListener('click', function () {
									self.changeDialogStates({ state: 'hidden' });
								}, false);
							} else {
								closeElement.attachEvent('onclick', function () {
									self.changeDialogStates({ state: 'hidden' });
									return false;
								});
							}

							self.cache.dialog = dialog;
						},

						/*
       * 改变dialog显示状态
       * @param {string} obj.state hidden|visible
       */
						changeDialogStates: function changeDialogStates(obj) {
							if (obj.state === 'hidden') {
								//清空拦截队列
								emit.fire('event:cleanHijackQueue@sufei', {});
								//隐藏dialog
								this.cache.dialog.style.display = 'none';
							} else {
								//显示dialog
								this.cache.dialog.style.display = 'block';
								//消息: 刷新验证码
								messengerHasInit && messenger.send({
									type: 'msg:refreshCheckCode@sufei',
									content: ''
								});
							}
						}
					};

					var sufeiMod = new Sufei();

					module.exports = {
						init: function init(config) {
							sufeiMod.init(config);
						}
					};
				});

				pointman.use('sufei', function (sufei) {
					sufei.init();
				});
			}).call(window);

			/***/
		}
		/******/])
	);
});
;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./components/mtop/build/index.js
 ** module id = 3
 ** module chunks = 0
 **/